import { useLogout } from "@lens-protocol/react-web";
import { useAccount, useDisconnect } from "wagmi";

import { Button } from "../Button";

export function DisconnectWalletButton() {
  const { isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { execute } = useLogout();

  const logout = () => {
    void execute();
    disconnect(undefined, {
      onSuccess: () => {
        if (!window) {
          return;
        }
        /**
         * On disconnect success, the useAccount hook's state won't automatically
         * update for some reason. On second click, it will update. So, we're
         * reloading the page to make sure the state is updated.
         */
        window.location.reload();
      },
    });
  };

  if (!isConnected) {
    return null;
  }

  return (
    <Button
      className="w-full text-gray-200"
      onClick={() => logout()}
      variant="ghost"
    >
      disconnect wallet
    </Button>
  );
}
